module.exports = __webpack_public_path__ + "static/media/placeholder-img-2.25d63ea8.png";